import React, { useCallback, useMemo, useRef } from "react";
import DLabGrid from "../../DLabGrid/DLabGrid";
// import SlotDetailCellRenderer from "./SlotDetailCellRenderer";
import { OwcTypography } from "@one/react";
import { convertCloudToGraphQLObj, valueOrEmpty } from "../../../utils/helpers/text";
import { OpenSearchConfig } from "../OpenSearchConfig";
import { CloudSearchConfig } from "../CloudSearchConfig";
import { OPENSEARCH_CONFIGURATION } from "../../../features/booking-instruments/helpers";
import { ENTRY_TYPE, POSITION_IN_CLUSTER, entryType, PopOverTableMeta, equipmentStatus } from "../../../constants";

const sortByPositionAscending = (data) => {
  return data.sort((a, b) => {
    const posA = Number(a.position_in_cluster ?? a._source?.position_in_cluster ?? 0);
    const posB = Number(b.position_in_cluster ?? b._source?.position_in_cluster ?? 0);

    return posA - posB;
  });
}
const PopOverClusterAgGridTable = ({ data }) => {
  const gridRef = useRef();
  const rowStyle = {
    background: "var(--one-color-cobas-accent-gray-100)",
  };
  const defaultColDef = {
    flex: 1,
    resizable: true,
    suppressMenu: true,
  };
  const isServerSideGroup = useCallback((dataItem) => {
    return dataItem.entryType === ENTRY_TYPE.cluster ? dataItem.id : "";
  }, []);

  const getServerSideGroupKey = useCallback((dataItem) => {
    return dataItem.entryType === ENTRY_TYPE.cluster ? dataItem.id : "";
  }, []);

  const dLabColumnDef = useMemo(() => {
    let defaultObj;
    let colDef = [];

    for (const key in PopOverTableMeta.fields) {
      defaultObj = {
        field: key,
        headerName: PopOverTableMeta.fields[key].text,
        valueFormatter: (params) => valueOrEmpty(params?.data[key], false, "-"),
      };

      colDef.push(defaultObj);
    }
    return colDef;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PopOverTableMeta.fields]);

  let attr = {
    rowModelType: "serverSide",
    rowQuickSearch: true,
    treeData: true,
    columnDefs: dLabColumnDef,
    animateRows: true,
    rowExport: false,
    defaultToolPanel: "filters",
    suppressContextMenu: true,
    hiddenByDefault: true,
    isServerSideGroup,
    getServerSideGroupKey,
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "Model",
      field: "equipmentModel",
      pinned: "left",
      lockPinned: true,
      cellStyle: (params) => {
        return params?.node?.level > 0 &&
          (params?.data?.entry_type === entryType?.cluster ||
            params?.data?.entry_type === entryType?.clusterSubequipment)
          ? {
            borderBottom: "1px solid #d3d3d3 !important",
            backgroundColor: "#F5F5F2",
            backgroundImage: "conic-gradient(at 7% 90%, #FFFFFF 180deg, #F5F5F2 180deg)",
          }
          : {
            marginLeft: "none !important",
          };
      },
      cellRendererParams: {
        innerRenderer: (params) => {
          return valueOrEmpty(params?.data?.equipmentModel, false, "-");
        },
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getServerSideDatasource = () => {
    return {
      getRows: async (params) => {
        const { startRow, groupKeys } = params.request;
        let clusterId = groupKeys.length > 0 ? groupKeys[params.parentNode.level] : data[0].inventoryId;
        // let filterQueryString = ` (or site_name:'${user.siteName}') (or status:'${equipmentStatus?.active?.value}') (or entry_type:'${ENTRY_TYPE.cluster}' entry_type:'${ENTRY_TYPE.standaloneEquipment}')  `;
        let searchValueString = `(status:"${equipmentStatus?.active?.value}" OR status:"${equipmentStatus?.pending?.value}") AND cluster_id:"${clusterId}"`;

        let filterQueryString = ``;

        let options = {
          start: startRow,
          size: 100,
          ...(!OPENSEARCH_CONFIGURATION && {
            sort: "asc",
            sortBy: POSITION_IN_CLUSTER,
          }),
          searchValue: searchValueString,
          filterQuery: filterQueryString,
        };

        let result = await (OPENSEARCH_CONFIGURATION ? OpenSearchConfig(options) : CloudSearchConfig(options));
        if (OPENSEARCH_CONFIGURATION) {
          result = { ...result, data: sortByPositionAscending(result.data) };
        }
        const modifiedData = result.data.map((x) => convertCloudToGraphQLObj(x));
        params.success({
          rowData: modifiedData,
          rowCount: result.count,
        });
      },
    };
  };
  const onGridReady = useCallback(async (params) => {
    const datasource = getServerSideDatasource();
    params.api.setServerSideDatasource(datasource);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <OwcTypography variant="button" style={{ marginBottom: 16 }}>
        Sub components
      </OwcTypography>
      <div className="ag-theme-alpine">
        <div className="sub-components-row">
          <div className={"sub-table-grid"}>
            <DLabGrid
              {...attr}
              pagination={false}
              suppressPaginationPanel={false}
              defaultColDef={defaultColDef}
              autoGroupColumnDef={autoGroupColumnDef}
              rowStyle={rowStyle}
              gridRef={gridRef}
              onGridReady={onGridReady}
              detailRowAutoHeight={true}
              domLayout="autoHeight"
              height={"100%"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopOverClusterAgGridTable;
